export default "__VITE_ASSET__BcJJsGxt__"